
























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Point } from './point.interface'
import {
  EasingCubicBezier,
  EasingPoints,
  toEasingCubicBezier
} from './easing-status.interface'

@Component
export default class EasingBall extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => [0.4, 0.1, 0.4, 0.8]
  })
  value!: EasingPoints
  @Prop({
    type: Number,
    required: false,
    default: 10
  })
  ballAmount!: number
  width!: number
  reStart: number = 1

  get easingCubicBezier(): EasingCubicBezier {
    return toEasingCubicBezier(this.value)
  }

  get pointA(): Point {
    return {
      cx: 0,
      cy: 0
    }
  }

  get pointB(): Point {
    return {
      cx: this.value[0],
      cy: this.value[1]
    }
  }

  get pointC(): Point {
    return {
      cx: this.value[2],
      cy: this.value[3]
    }
  }

  get pointD(): Point {
    return {
      cx: 1,
      cy: 1
    }
  }

  get stylesObject() {
    return {
      'transition-timing-function': this.easingCubicBezier,
      'transition-duration': '1.5s',
      'transition-delay': `0s`,
      'transition-property': 'left'
      // left: `calc(100% - 100px)`,
      // 'animation-timing-function': this.easingCubicBezier
    }
  }

  residualBallStyles(t: number) {
    // console.log(this.clientWidth, this.$el.clientWidth)
    // const width = 400
    return {
      'transition-delay': `${t}s`,
      'transition-property': 'opacity',
      // opacity: 1,
      left: `${this.getPositionX(t) * this.width}px`
    }
  }

  getPositionX(t: number): number {
    return (
      Math.pow(1 - t, 3) * this.pointA.cy +
      3 * Math.pow(1 - t, 2) * t * this.pointB.cy +
      3 * (1 - t) * Math.pow(t, 2) * this.pointC.cy +
      Math.pow(t, 3) * this.pointD.cy
    )
  }

  handleClick() {
    this.reStart++
  }

  mounted() {
    this.$nextTick(() => {
      this.width = ((this.$el && this.$el.clientWidth) || 300) - 100
    })
  }
}
